export default potBalance

/** @ngInject */
function potBalance(PotManager) {
    return ({
        restrict: 'E',
        template: '<span>{{pot.real | frAmount}}€</span>',
        link(scope) {
            scope.pot = PotManager.getPotBalance()
            PotManager.watch((newPot) => {
                scope.pot = newPot
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/pot-balance/directive.js